import { useTranslation } from "react-i18next";
import { AppSelect } from "@/components/app/AppSelect";
import { SUPPORTED_LOCALES, useChangeLocale, type AppLocale } from "@/lib/locale";

/**
 * Výběr jazyka rozhraní. Rozbalovací seznam, ne segmentový přepínač: jazyků může
 * přibýt a každý další segment by roztahoval horní lištu i menu účtu, kde je
 * místa nejmíň.
 *
 * Volba se ukládá na server (k účtu), protože platí i pro texty renderované
 * backendem — proto je po dobu mutace zakázaný.
 *
 * Záměrně bez vlajek: vlajka je stát, ne jazyk (angličtina ≠ USA).
 */
export interface LocaleSelectProps {
  /** `false` = šířka podle obsahu (horní lišta), `true` = přes celou šířku (menu účtu). */
  fullWidth?: boolean;
  className?: string;
}

export function LocaleSelect({ fullWidth = true, className }: LocaleSelectProps) {
  const { t, i18n } = useTranslation();
  const changeLocale = useChangeLocale();

  return (
    <AppSelect
      aria-label={t("locale.label")}
      value={i18n.language as AppLocale}
      disabled={changeLocale.isPending}
      fullWidth={fullWidth}
      className={className}
      onChange={(e) => changeLocale.mutate(e.target.value as AppLocale)}
    >
      {SUPPORTED_LOCALES.map((lang) => (
        <option key={lang} value={lang}>
          {t(`locale.${lang}`)}
        </option>
      ))}
    </AppSelect>
  );
}
